export {default} from './chatModel';
export * from './chatModel';



// WEBPACK FOOTER //
// ./src/models/chatModel/index.ts